// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swim-lanes-container {
  background-color: var(--ion-color-tertiary);
  padding: 0.25rem;
  margin: 0.25rem;
  border-radius: 1rem;
}
.swim-lanes-container .swim-lane-see-all {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.swim-lanes-container .swim-lane-see-all p {
  font-family: var(--font-secondary);
  color: var(--ion-color-light);
  font-weight: 600;
  font-size: 1.25rem;
  margin: 0.5rem 0 1rem 3rem;
}
@media screen and (max-width: 768px) {
  .swim-lanes-container .swim-lane-see-all p {
    margin-left: 1rem;
  }
}
.swim-lanes-container .swim-lane-see-all .see-all {
  cursor: pointer;
}
.swim-lanes-container .swim-lanes {
  margin: 0 0.5rem;
  display: flex;
  overflow: hidden;
  gap: 0.5rem;
  scroll-snap-type: x mandatory;
  padding-bottom: 1rem;
}
.swim-lanes-container app-game-tile {
  flex: 0 0 calc((100% - 4rem) / 6);
  scroll-snap-align: center;
  aspect-ratio: 1/1;
}
@media screen and (max-width: 992px) {
  .swim-lanes-container app-game-tile {
    flex: 0 0 calc((100% - 3rem) / 4);
  }
}
@media screen and (max-width: 576px) {
  .swim-lanes-container {
    border-radius: 0;
    padding: 0;
    margin: 0;
    margin-top: 1px;
  }
  .swim-lanes-container app-game-tile {
    flex: 0 0 calc((100% - 2rem) / 2);
  }
  .swim-lanes-container .swim-lanes {
    overflow: auto;
  }
}

@media screen and (min-width: 550px) {
  ::-webkit-scrollbar {
    height: 0.25rem;
  }
}

@media screen and (min-width: 550px) {
  ::-webkit-scrollbar-track {
    border-radius: 0.5rem;
    background-color: var(--ion-color-secondary-tint);
    cursor: pointer;
  }
}

@media screen and (min-width: 550px) {
  ::-webkit-scrollbar-thumb {
    background-color: var(--ion-color-light);
    border-radius: 0.5rem;
    cursor: pointer;
  }
}

@media screen and (min-width: 780px) {
  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--ion-color-light);
  }
}

.scroll-left-button,
.scroll-right-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #b3d7f1;
  border-radius: 50%;
  transform: translateY(2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.scroll-left-button ion-icon,
.scroll-right-button ion-icon {
  font-size: 1.2rem;
  padding: 8px;
}

.swim-lane-horizontal-lane {
  display: flex;
  align-items: center;
}

.scroll-left-button,
.scroll-right-button {
  flex-shrink: 0;
}

.swim-lanes {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  flex-grow: 1;
}

p {
  text-transform: lowercase;
  font-family: var(--font-secondary) !important;
}

p:first-letter {
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/components/swim-lanes/swim-lanes.component.scss"],"names":[],"mappings":"AAAA;EACI,2CAAA;EAEA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AADR;AAGQ;EACI,kCAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AADZ;AAIQ;EACI;IACI,iBAAA;EAFd;AACF;AAKQ;EACI,eAAA;AAHZ;AAOI;EACI,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,6BAAA;EACA,oBAAA;AALR;AAUI;EACI,iCAAA;EACA,yBAAA;EACA,iBAAA;AARR;AAWI;EACI;IACI,iCAAA;EATV;AACF;AAaI;EAxDJ;IAyDQ,gBAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;EAVN;EAYM;IACI,iCAAA;EAVV;EAaM;IACI,cAAA;EAXV;AACF;;AAiBI;EADJ;IAEQ,eAAA;EAbN;AACF;;AAiBI;EADJ;IAEQ,qBAAA;IACA,iDAAA;IACA,eAAA;EAbN;AACF;;AAiBI;EADJ;IAEQ,wCAAA;IACA,qBAAA;IACA,eAAA;EAbN;AACF;;AAiBI;EADJ;IAEQ,wCAAA;EAbN;AACF;;AAgBA;;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,wCAAA;EACA,eAAA;EACA,sCAAA;AAbJ;AAeI;;EACI,iBAAA;EACA,YAAA;AAZR;;AAgBA;EACI,aAAA;EACA,mBAAA;AAbJ;;AAgBA;;EAEI,cAAA;AAbJ;;AAiBA;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAdJ;;AAiBA;EACI,yBAAA;EACA,6CAAA;AAdJ;;AAiBA;EACI,yBAAA;AAdJ","sourcesContent":[".swim-lanes-container {\r\n    background-color: var(--ion-color-tertiary);\r\n\r\n    padding: .25rem;\r\n    margin: .25rem;\r\n    border-radius: 1rem;\r\n\r\n\r\n    .swim-lane-see-all {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n\r\n        p {\r\n            font-family: var(--font-secondary);\r\n            color: var(--ion-color-light);\r\n            font-weight: 600;\r\n            font-size: 1.25rem;\r\n            margin: 0.5rem 0 1rem 3rem;\r\n        }\r\n\r\n        @media screen and (max-width: 768px) {\r\n            p {\r\n                margin-left: 1rem;\r\n            }\r\n        }\r\n\r\n        .see-all {\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .swim-lanes {\r\n        margin: 0 0.5rem;\r\n        display: flex;\r\n        overflow: hidden;\r\n        gap: .5rem;\r\n        scroll-snap-type: x mandatory;\r\n        padding-bottom: 1rem;\r\n\r\n        //@include SwimLanesScrollbar();\r\n    }\r\n\r\n    app-game-tile {\r\n        flex: 0 0 calc((100% - 4rem) / 6);\r\n        scroll-snap-align: center;\r\n        aspect-ratio: 1/1;\r\n    }\r\n\r\n    @media screen and (max-width: 992px) {\r\n        app-game-tile {\r\n            flex: 0 0 calc((100% - 3rem) / 4);\r\n\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 576px) {\r\n        border-radius: 0;\r\n        padding: 0;\r\n        margin: 0;\r\n        margin-top: 1px;\r\n\r\n        app-game-tile {\r\n            flex: 0 0 calc((100% - 2rem) / 2);\r\n        }\r\n\r\n        .swim-lanes {\r\n            overflow: auto;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n::-webkit-scrollbar {\r\n    @media screen and (min-width: 550px) {\r\n        height: .25rem;\r\n    }\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    @media screen and (min-width: 550px) {\r\n        border-radius: 0.5rem;\r\n        background-color: var(--ion-color-secondary-tint);\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    @media screen and (min-width: 550px) {\r\n        background-color: var(--ion-color-light);\r\n        border-radius: .5rem;\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n    @media screen and (min-width: 780px) {\r\n        background-color: var(--ion-color-light);\r\n    }\r\n}\r\n\r\n.scroll-left-button,\r\n.scroll-right-button {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #b3d7f1;\r\n    border-radius: 50%;\r\n    transform: translateY(2px);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n\r\n    ion-icon {\r\n        font-size: 1.2rem;\r\n        padding: 8px;\r\n    }\r\n}\r\n\r\n.swim-lane-horizontal-lane {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.scroll-left-button,\r\n.scroll-right-button {\r\n    flex-shrink: 0;\r\n    // padding: 0 10px;\r\n}\r\n\r\n.swim-lanes {\r\n    display: flex;\r\n    overflow-x: auto;\r\n    scroll-behavior: smooth;\r\n    flex-grow: 1;\r\n}\r\n\r\np {\r\n    text-transform: lowercase;\r\n    font-family: var(--font-secondary) !important;\r\n}\r\n\r\np:first-letter {\r\n    text-transform: uppercase;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
